import React, { useRef } from "react";
import emailjs from "emailjs-com";
import "../components/styles/Contact.css";

export default function Contact() {
  const formRef = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_4d5l3bb",      // replace
        "template_js44sie",     // replace
        formRef.current,
        "rm4Ph_nZsQL2gMF1j"       // replace
      )
      .then(
        () => {
          alert("Message sent successfully!");
          formRef.current.reset();
        },
        (error) => {
          alert("Failed to send message!");
          console.error(error);
        }
      );
  };

  return (
    <section className="contact-page">
      <h2>Contact Us</h2>

      <form className="contact-form" ref={formRef} onSubmit={sendEmail}>

        {/* Name */}
        <input
          type="text"
          name="name"
          placeholder="Your Name"
          required
        />

        {/* Email */}
        <input
          type="email"
          name="email"
          placeholder="Your Email"
          required
        />

        {/* Title (Subject) */}
        {/* <input
          type="text"
          name="title"
          placeholder="Subject"
          required
        /> */}

        {/* Message */}
        <textarea
          name="message"
          placeholder="Your Message"
          rows="4"
          required
        ></textarea>

        <button type="submit">Send Message</button>
      </form>
    </section>
  );
}
